import { NgxLoggerLevel } from 'ngx-logger';

export const TcLoggerLevel = {
  ...NgxLoggerLevel,
};
